/**
 * The Log level is a Priority for each log message as a decimal Severity level indicator.
 *
 * @see https://tools.ietf.org/html/rfc5424#section-6.2.1
 */
export enum LogLevel {
  /**
   * System is unusable.
   */
  EMERGENCY = 0,
  /**
   * Action must be taken immediately.
   *
   * Example: Entire website down, database unavailable, etc. This should
   * trigger the SMS alerts and wake you up.
   */
  ALERT = 1,
  /**
   * Critical conditions.
   *
   * Example: Application component unavailable, unexpected exception.
   */
  CRITICAL = 2,
  /**
   * Runtime errors that do not require immediate action but should typically
   * be logged and monitored.
   */
  ERROR = 3,
  /**
   * Exceptional occurrences that are not errors.
   *
   * Example: Use of deprecated APIs, poor use of an API, undesirable things
   * that are not necessarily wrong.
   */
  WARNING = 4,
  /**
   * Normal but significant events.
   */
  NOTICE = 5,
  /**
   * Interesting events.
   *
   * Example: User logs in, SQL logs.
   */
  INFO = 6,
  /**
   * Detailed debug information.
   */
  DEBUG = 7,
}
